import { GhostPlayer } from "./ghost-player";

interface VideoBackgroundProps {
	variant?: "light" | "dark";
	children: React.ReactNode;
	className?: string;
}

export function VideoBackground({
	variant = "light",
	children,
	className,
}: VideoBackgroundProps) {
	const baseOpacity = variant === "light" ? 0.04 : 0.06;

	return (
		<div
			className={className}
			style={{ position: "relative", overflow: "hidden" }}
		>
			{/* Ghost player — top right */}
			<GhostPlayer
				size="md"
				rotation={5}
				opacity={baseOpacity}
				progressFill={0.35}
				style={{
					top: -10,
					right: -20,
					["--ghost-x" as string]: "0px",
					["--ghost-y" as string]: "0px",
				}}
			/>

			{/* Ghost player — bottom left */}
			<GhostPlayer
				size="sm"
				rotation={-7}
				opacity={baseOpacity * 0.8}
				progressFill={0.6}
				style={{
					bottom: -5,
					left: -15,
					["--ghost-x" as string]: "0px",
					["--ghost-y" as string]: "0px",
				}}
			/>

			{/* Ghost player — center-right offset */}
			<GhostPlayer
				size="sm"
				rotation={3}
				opacity={baseOpacity * 0.5}
				progressFill={0.8}
				style={{
					top: "45%",
					right: "8%",
					["--ghost-x" as string]: "0px",
					["--ghost-y" as string]: "0px",
				}}
			/>

			{/* Content on top */}
			<div style={{ position: "relative", zIndex: 1 }}>{children}</div>
		</div>
	);
}
